<template>
  <transition name="confirm-fade">
    <div v-if="show" class="confirm-dialog" role="dialog" aria-modal="true">
      <div class="confirm-dialog__backdrop" @click="onCancel"></div>
      <div class="confirm-dialog__box" :class="`confirm-dialog__box--${variant}`">
        <div class="confirm-dialog__icon" :class="`confirm-dialog__icon--${variant}`">
          <!-- Danger: trash -->
          <svg v-if="variant === 'danger'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
            <path d="M10 11v6"></path>
            <path d="M14 11v6"></path>
            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
          </svg>
          <!-- Warning: alert triangle -->
          <svg v-else-if="variant === 'warning'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <!-- Info: question mark -->
          <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <h3 class="confirm-dialog__title">{{ title }}</h3>
        <p class="confirm-dialog__message">{{ message }}</p>
        <div class="confirm-dialog__actions">
          <button type="button" class="btn btn--outline" :disabled="loading" @click="onCancel">
            {{ cancelText }}
          </button>
          <button type="button" class="btn"
                  :class="[`btn--${variant}`, { 'is-loading': loading }]"
                  :disabled="loading"
                  @click="onConfirm">
            <span v-if="!loading">{{ confirmText }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmar'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Confirmar'
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    },
    // danger | warning | info
    variant: {
      type: String,
      default: 'danger',
      validator: (v) => ['danger', 'warning', 'info'].includes(v)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel'],
  methods: {
    onConfirm () {
      if (this.loading) return
      this.$emit('confirm')
    },
    onCancel () {
      if (this.loading) return
      this.$emit('cancel')
    }
  }
}
</script>
